// src/utils/constants.js

import {
    Briefcase, Coffee, Monitor, Layers, Film, Handshake, Gift
} from 'lucide-react';

const getGlobalVar = (name) => {
  let value;
  if (typeof window !== "undefined" && window[name] !== undefined) {
    value = window[name];
  } else if (typeof global !== "undefined" && global[name] !== undefined) {
    value = global[name];
  }
  return (typeof value !== 'undefined' && value !== 'undefined' && value !== null) ? value : null;
};

export const globalAppId = getGlobalVar('__app_id') || 'ranking-rp-metodos-4aad2';
const rawFirebaseConfig = getGlobalVar('__firebase_config');

const FALLBACK_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBRFrDeTUzYpuy05Vv2e6MbPYORwFlISQU',
  authDomain: 'ranking-rp-metodos-4aad2.firebaseapp.com',
  projectId: 'ranking-rp-metodos-4aad2',
  storageBucket: 'ranking-rp-metodos-4aad2.firebasestorage.app',
  messagingSenderId: '342047315639',
  appId: '1:342047315639:web:f7a3cadf055a0f8d685f32',
};

let parsedFirebaseConfig = FALLBACK_FIREBASE_CONFIG;
if (rawFirebaseConfig) {
  try {
    parsedFirebaseConfig = JSON.parse(rawFirebaseConfig);
  } catch (e) {
    console.warn('Falha ao parsear __firebase_config, usando configuração padrão.', e);
  }
}
export const globalFirebaseConfig = parsedFirebaseConfig;

export const globalAuthToken = getGlobalVar('__initial_auth_token');

export const USER_ROLE_EMPLOYEE = 1;
export const USER_ROLE_MANAGER = 2;
export const USER_ROLE_ANALYST = 3;

export const USER_SECTORS = [
    'Contabilidade', 'Fiscal', 'DP', 'Societário', 'Financeiro', 'TI', 'Administradores', 'Outros'
];

// --- NOMES DE ARQUIVO GERAIS ---
export const REAL_HEADER_LOGO_FILENAME = "Designer/Banner Site.jpg";
export const REAL_LOGIN_BACKGROUND_FILENAME = "Designer/rECEPÇÃO.jpg";
export const REAL_GENERAL_BACKGROUND_FILENAME = "Designer/Fundo Site.jpg";
export const REAL_WELCOME_BACKGROUND_FILENAME = "Designer/fundowelcome.jpg";
// 🟢 FAVICON ALTERADO
export const REAL_FAVICON_FILENAME = "RPImagens/Favicon.jpg";
export const REAL_LOGIN_LOGO_FILENAME = "RPImagens/RP_Logo_NovoCompacto.jpeg";
export const REAL_RANKING_TITLE_FILENAME = "Designer/Ranking.jpg";

export const REAL_SHOP_LOGO_FILENAME = "RPImagens/logo sem fundo.png";
export const SHOP_CATEGORY_MARCA_FILENAME = "RPImagens/RP_Logo_Novo.jpeg";
export const SHOP_CATEGORY_LOGO_FILENAME = "RPImagens/logo sem fundo.png";

// --- URLs DE FALLBACK ---
export const FALLBACK_LOGO_URL = "https://placehold.co/1500x100/4F46E5/FFFFFF?text=RPLAY+BANNER+COMPLETO";
export const FALLBACK_BACKGROUND_URL = "https://placehold.co/1000x1000/F3F4F6/6B7280?text=Fundo+Login";
export const FALLBACK_GENERAL_BACKGROUND_URL = "https://placehold.co/1920x1080/E0E7FF/4F46E5?text=Background";
export const FALLBACK_CATEGORY_MARCA_URL = "https://placehold.co/100x100/A78BFA/FFFFFF?text=RP+LOGO";
export const FALLBACK_SHOP_LOGO_URL = "https://placehold.co/100x100/4F46E5/FFFFFF?text=R+P+L";
export const FALLBACK_ITEM_IMAGE_URL = (name) => `https://placehold.co/300x100/A78BFA/FFFFFF?text=${encodeURIComponent(name.substring(0, 15))}`;

export const SHOP_ITEM_IMAGE_FILENAMES = {
  'Kit Barbeador ou Kit Esmalte (4 unid.)': 'Lojinha/Kit Barbeador ou Kit Esmalte.png',
  'Kit Básico Escritório (Estojo/Bloco/Caneta)': 'Lojinha/Kit Básico Escritório.png',
  'Kit Hidratação Cabelo/Corpo': 'Lojinha/Kit Hidratação CabeloCorpo.png',
  'Nécessaire Premium / Marmita Térmica': 'Lojinha/Necessaire Premium.png',
  'Vale Salão (Serviço até R$150)': 'Lojinha/Vale Salão.png',
  'Snack Simples': 'Lojinha/Snack Simples.png',
  'Caixa de Bombom / Kit Doce ou Salgado': 'Lojinha/Caixa de Bombom.png',
  'Vale Café (R$25)': 'Lojinha/Vale Café (R$25).png',
  'Vale Refeição (R$50)': 'Lojinha/Vale Refeição (R$50).png',
  'Jogo de Canetas / Blocos (Premium)': 'Lojinha/Jogo de Canetas.png',
  'Porta-Retratos Clean / Suporte de Notebook': 'Lojinha/Porta Retratos.png',
  'Fone Intra/Over Simples / Suporte Celular': 'Lojinha/Fones.png',
  'Agenda RP': 'Lojinha/Agenda RP.png',
  'Copo Térmico RP / Cuia de Chimarrão RP': 'Lojinha/Copo Termico Cuia RP.png',
  'Camisa Polo RP': 'Lojinha/Camiseta rp.png',
  '2 Ingressos de Cinema': 'Lojinha/Ingressos Cinema.png',
  'VALE CLIENTE: Lovinwine (Mix R$75)': 'Lojinha/loving.jfif',
  'VALE CLIENTE: Devi (Mix R$75)': 'Lojinha/devi.jpeg',
  'VALE CLIENTE: MundoVerde (Mix R$75)': 'Lojinha/mundoverde.jpeg',
  'VALE CLIENTE: Yuool (Desconto Tênis)': 'Lojinha/merino.png',
  'VALE CLIENTE: WSmart Restaurante (Vale Jantar)': 'Lojinha/wsmart.jpg',
  'Vale Combustível (R$100)': 'Lojinha/Vale Combustível (R$100).png',
  'Mateira Térmica e Cuia': 'Lojinha/Mateira Termica e Cuia.png',
  'Vale Massagem': 'Lojinha/Vale Massagem.png',
  'Kit Final de Semana (Bebidas + Aperitivos)': 'Lojinha/Kit Final de Semana.png',
  'Cesta Piquenique (Até R$150)': 'Lojinha/Cesta Piquenique.png',
  'Kit Churrasco (Até R$150)': 'Lojinha/Kit Churrasco.png',
};

export const SHOP_ITEMS = [
  {
      category: 'Essenciais & Cuidados Pessoais',
      icon: Briefcase,
      image: "Lojinha/01loja.png",
      items: [
          { name: 'Kit Básico Escritório (Estojo/Bloco/Caneta)', cost: 80, realCost: 8.00, initialStock: 100 },
          { name: 'Kit Barbeador ou Kit Esmalte (4 unid.)', cost: 200, realCost: 20.00, initialStock: 100 },
          { name: 'Nécessaire Premium / Marmita Térmica', cost: 500, realCost: 50.00, initialStock: 100 },
          { name: 'Kit Hidratação Cabelo/Corpo', cost: 1000, realCost: 100.00, initialStock: 100 },
          { name: 'Vale Salão (Serviço até R$150)', cost: 1500, realCost: 150.00, initialStock: 100 },
      ],
  },
  {
      category: 'Snacks & Perecíveis',
      icon: Coffee,
      image: "Lojinha/02loja.png",
      items: [
          { name: 'Snack Simples', cost: 80, realCost: 5.00, initialStock: 100 },
          { name: 'Vale Café (R$25)', cost: 250, realCost: 25.00, initialStock: 100 },
          { name: 'Caixa de Bombom / Kit Doce ou Salgado', cost: 300, realCost: 30.00, initialStock: 100 },
          { name: 'Vale Refeição (R$50)', cost: 500, realCost: 50.00, initialStock: 100 },
      ],
  },
  {
      category: 'Escritório & Tech',
      icon: Monitor,
      image: "Lojinha/03loja.png",
      items: [
          { name: 'Jogo de Canetas / Blocos (Premium)', cost: 200, realCost: 20.00, initialStock: 100 },
          { name: 'Porta-Retratos Clean / Suporte de Notebook', cost: 500, realCost: 50.00, initialStock: 100 },
          { name: 'Fone Intra/Over Simples / Suporte Celular', cost: 1000, realCost: 100.00, initialStock: 100 },
      ],
  },
  {
      category: 'Marca RP (Orgulho de Pertencer)',
      icon: Layers,
      image: SHOP_CATEGORY_MARCA_FILENAME,
      items: [
          { name: 'Agenda RP', cost: 500, realCost: 45.00, initialStock: 100 },
          { name: 'Copo Térmico RP / Cuia de Chimarrão RP', cost: 750, realCost: 75.00, initialStock: 100 },
          { name: 'Camisa Polo RP', cost: 1000, realCost: 90.00, initialStock: 100 },
      ],
  },
  {
      category: 'Lazer & Entretenimento',
      icon: Film,
      image: "Lojinha/04loja.png",
      items: [
          { name: '2 Ingressos de Cinema', cost: 500, realCost: 50.00, initialStock: 100 }
      ],
  },
  {
      category: 'Parcerias Especiais',
      icon: Handshake,
      image: "Lojinha/05loja.png",
      items: [
          { name: 'VALE CLIENTE: Lovinwine (Mix R$75)', cost: 750, realCost: 75.00, initialStock: 100 },
          { name: 'VALE CLIENTE: Devi (Mix R$75)', cost: 750, realCost: 75.00, initialStock: 100 },
          { name: 'VALE CLIENTE: MundoVerde (Mix R$75)', cost: 750, realCost: 75.00, initialStock: 100 },
          { name: 'VALE CLIENTE: Yuool (Desconto Tênis)', cost: 1500, realCost: 150.00, initialStock: 100 },
          { name: 'VALE CLIENTE: WSmart Restaurante (Vale Jantar)', cost: 1500, realCost: 150.00, initialStock: 100 },
      ],
  },
  {
      category: 'Top 5 (Limitado e Experiências)',
      icon: Gift,
      image: "Lojinha/06loja.png",
      items: [
          { name: 'Vale Combustível (R$100)', cost: 1000, realCost: 100.00, initialStock: 100 },
          { name: 'Mateira Térmica e Cuia', cost: 1000, realCost: 100.00, initialStock: 100 },
          { name: 'Vale Massagem', cost: 1000, realCost: 100.00, initialStock: 100 },
          { name: 'Kit Final de Semana (Bebidas + Aperitivos)', cost: 1500, realCost: 150.00, initialStock: 100 },
          { name: 'Cesta Piquenique (Até R$150)', cost: 1500, realCost: 150.00, initialStock: 100 },
          { name: 'Kit Churrasco (Até R$150)', cost: 1500, realCost: 150.00, initialStock: 100 },
      ],
  },
];
export { SHOP_ITEMS as SHOP_ITEMS_CONFIG };

export const BASE_ACTIVITIES = [
  { category: 'Analise de Desempenho', activity: 'Assiduidade (Mês sem faltas)', points: 100 },
  { category: 'Analise de Desempenho', activity: 'Pontualidade 80%', points: 80 },
  { category: 'Analise de Desempenho', activity: 'Pontualidade 100%', points: 110 },
  { category: 'Analise de Desempenho', activity: 'Postura & Comportamento (Avaliação Gestor) 80%', points: 80 },
  { category: 'Analise de Desempenho', activity: 'Postura & Comportamento (Avaliação Gestor) 100%', points: 110 },
  { category: 'Analise de Desempenho', activity: 'Colaboração & Ajuda (Ato registrado de ajuda)', points: 40 },
  { category: 'Analise Tecnica', activity: 'Prazos & Entregas 80%', points: 80 },
  { category: 'Analise Tecnica', activity: 'Prazos & Entregas 100%', points: 110 },
  { category: 'Analise Tecnica', activity: 'Qualidade (Entrega sem retrabalho) 80%', points: 80 },
  { category: 'Analise Tecnica', activity: 'Qualidade (Entrega sem retrabalho) 100%', points: 100 },
  { category: 'Analise Tecnica', activity: 'Qualidade (Entrega sem retrabalho) 120%', points: 150 },
  { category: 'Analise Tecnica', activity: 'Organização & Documentação (Entrega/Projeto)', points: 20 },
  { category: 'Especiais', activity: 'Sugestão Aprovada ★ Impacto Baixo (fluxos e rotina individual)', points: 100 },
  { category: 'Especiais', activity: 'Sugestão Aprovada ★★ Impacto Médio (setor e processos)', points: 200 },
  { category: 'Especiais', activity: 'Sugestão Aprovada ★★★ Impacto Alto (empresa e negócio)', points: 350 },
  { category: 'Especiais', activity: 'Curso (Com Certificado) - Custeado pela Empresa', points: 150 },
  { category: 'Especiais', activity: 'Curso (Sem Certificado) - Custeado pela Empresa', points: 50 },
  { category: 'Especiais', activity: 'Curso (Com Certificado) - Custeado pelo Funcionário (Iniciativa)', points: 300 },
  { category: 'Especiais', activity: 'Curso (Sem Certificado) - Custeado pelo Funcionário (Iniciativa)', points: 100 },

  // NOVAS REGRAS
  { category: 'Cultura', activity: 'Recebeu um "Valeu!" de colega (Aprovação)', points: 50 },
  { category: 'Qualidade', activity: 'Caçador de Bugs (Erro encontrado antes do cliente)', points: 30 },
];

export const GUIDE_ACTIVITIES = {
  'Analise de Desempenho': BASE_ACTIVITIES.filter(a => a.category === 'Analise de Desempenho'),
  'Analise Tecnica': BASE_ACTIVITIES.filter(a => a.category === 'Analise Tecnica'),
  'Especiais': BASE_ACTIVITIES.filter(a => a.category === 'Especiais'),
  'Cultura & Qualidade': BASE_ACTIVITIES.filter(a => a.category === 'Cultura' || a.category === 'Qualidade'),
};

export const PENALTY_ACTIVITIES = [
  { activity: 'Reclamação do Cliente (deduzido após verificação dos fatos)', points: -1500, color: 'text-red-600' },
  { activity: 'Tudo que fere a cultura, valor e normas da RP', points: -750, color: 'text-red-600' },
  { activity: 'Atraso/Multa significativa e desnecessária', points: -500, color: 'text-red-600' },
];

/**
 * Matriz de critérios para o painel de gestão de pontos.
 * Fonte única de verdade — derivada de BASE_ACTIVITIES e PENALTY_ACTIVITIES.
 * roleAllowed define quais roles podem usar cada categoria.
 */
export const CRITERIA_MATRIX = [
  {
    id: 'desempenho',
    label: 'ANÁLISE DE DESEMPENHO',
    roleAllowed: [3],
    items: BASE_ACTIVITIES.filter(a => a.category === 'Analise de Desempenho')
      .map(a => ({ label: a.activity, points: a.points })),
  },
  {
    id: 'tecnica',
    label: 'ANÁLISE TÉCNICA',
    roleAllowed: [2, 3],
    items: BASE_ACTIVITIES.filter(a => a.category === 'Analise Tecnica')
      .map(a => ({ label: a.activity, points: a.points })),
  },
  {
    id: 'especiais',
    label: 'ESPECIAIS',
    roleAllowed: [3],
    items: BASE_ACTIVITIES.filter(a => a.category === 'Especiais')
      .map(a => ({ label: a.activity, points: a.points })),
  },
  {
    id: 'cultura',
    label: 'CULTURA & QUALIDADE',
    roleAllowed: [3],
    items: BASE_ACTIVITIES.filter(a => a.category === 'Cultura' || a.category === 'Qualidade')
      .map(a => ({ label: a.activity, points: a.points })),
  },
  {
    id: 'penalidades',
    label: 'PENALIDADES (DEDUÇÕES)',
    roleAllowed: [3],
    // Pontos como valor positivo — handlePenalizePoints aplica o sinal negativo
    items: PENALTY_ACTIVITIES.map(a => ({ label: a.activity, points: Math.abs(a.points) })),
  },
];
